import React from 'react';
import Icon from '../../../components/AppIcon';

const AssessmentStats = ({ assessments }) => {
  const stats = {
    total: assessments?.length,
    open: assessments?.filter(a => a?.status === 'open')?.length,
    inReview: assessments?.filter(a => a?.status === 'in-review')?.length,
    remediation: assessments?.filter(a => a?.status === 'remediation')?.length,
    closed: assessments?.filter(a => a?.status === 'closed')?.length,
    overdue: assessments?.filter(a => 
      new Date(a.dueDate) < new Date() && a?.status !== 'closed'
    )?.length,
    critical: assessments?.filter(a => a?.priority === 'critical')?.length,
    avgGap: assessments?.length > 0 
      ? (assessments?.reduce((sum, a) => sum + parseFloat(a?.gapPercentage), 0) / assessments?.length)?.toFixed(1)
      : 0
  };

  const statCards = [
    {
      title: 'Total Assessments',
      value: stats?.total,
      icon: 'FileCheck',
      color: 'text-foreground',
      bgColor: 'bg-muted'
    },
    {
      title: 'Open Cases',
      value: stats?.open,
      icon: 'AlertCircle',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      title: 'In Review',
      value: stats?.inReview,
      icon: 'Eye',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      title: 'Remediation',
      value: stats?.remediation,
      icon: 'Wrench',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      title: 'Overdue',
      value: stats?.overdue,
      icon: 'Clock',
      color: 'text-destructive',
      bgColor: 'bg-destructive/10'
    },
    {
      title: 'Critical Priority',
      value: stats?.critical,
      icon: 'AlertTriangle',
      color: 'text-destructive',
      bgColor: 'bg-destructive/10'
    },
    {
      title: 'Avg Gap',
      value: `${stats?.avgGap}%`,
      icon: 'TrendingUp',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      title: 'Closed',
      value: stats?.closed,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4 mb-6">
      {statCards?.map((stat, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-4 hover:shadow-soft transition-smooth"
        >
          <div className="flex items-center justify-between mb-2">
            <div className={`w-8 h-8 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={16} className={stat?.color} />
            </div>
          </div>
          <div className="space-y-1">
            <p className={`text-2xl font-bold ${stat?.color}`}>
              {stat?.value}
            </p>
            <p className="text-xs text-muted-foreground font-medium">
              {stat?.title}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AssessmentStats;